export const COMPARISON_FILTER = 'COMPARISON_FILTER';
